module.exports = __webpack_public_path__ + "static/img/qr3.864759d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qr3.png
// module id = 396
// module chunks = 12 14